'use strict';

import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.value("$modalDefaultOptions", {
  width: 800,
  fullWidth: false,
  escape: true,
  draggable: true
});
ngModule.directive("modalContainer", function () {
  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: '<div class="tl-modal-container"></div>'
  };
});
ngModule.directive('modalOverlay', function () {
  return {
    restrict: 'E',
    replace: true,
    template: '<div class="tl-modal-overlay"></div>'
  };
});
ngModule.directive('modalDialog', function ($animate) {
  return {
    restrict: 'E',
    scope: true,
    replace: true,
    transclude: true,
    template: '' + '<div class="tl-modal-dialog-container" ng-style="{ \'z-index\' : $zIndex }">' + '   <div class="tl-modal-dialog">' + '       <div class="tl-modal-content" ng-transclude></div>' + '   </div>' + '</div>',
    link: function link($scope, $el, $attrs) {
      var options = $scope.modalOptions;
      var dialogEl = $el.find(".tl-modal-content");
      if (dialogEl == null) {
        return;
      }
      if (options.fullWidth) {
        dialogEl.addClass("full-width");
      } else {
        dialogEl.width(options.width);
      }
      if (options.dialogClass) {
        dialogEl.addClass(options.dialogClass);
      }
      if (options.draggable) {
        // Switch to absolute positioning on mousedown to ensure Draggable calculates correct starting position
        dialogEl.on("mousedown", ".title", function (event) {
          if (event.which !== 1) return; // Only left click

          if (dialogEl.css("position") !== "absolute") {
            var rect = dialogEl[0].getBoundingClientRect();
            dialogEl.css({
              position: "absolute",
              top: rect.top + "px",
              left: rect.left + "px",
              margin: 0,
              right: "auto",
              bottom: "auto"
            });
          }
        });
        dialogEl.draggable({
          handle: ".title",
          containment: "window",
          start: function start(event, ui) {
            $("body").addClass("tl-modal-dragging");
          },
          stop: function stop() {
            $("body").removeClass("tl-modal-dragging");
          }
        });
        dialogEl.on("dblclick", ".title", function () {
          dialogEl.css({
            position: "",
            top: "",
            left: "",
            margin: "",
            right: "",
            bottom: ""
          });
        });
      }
      $animate.addClass(dialogEl, "tla-ready");
    }
  };
});
ngModule.factory('$modal', function ($compile, $animate, $rootScope, $window, $q, templateUtils, $controller, $modalDefaultOptions, keyCodes, deferredUtils) {
  var $modal = {},
    container = null,
    overlay = null,
    openedDialogs = [];
  $rootScope.$on("$locationChangeStart", function (event, next, current) {
    // $locationChangeStart ==> $locationChangeSuccess
    if (openedDialogs.length > 0) {
      var dialog = getCurrentDialog();
      dialog.scope.$dismiss();
      event.preventDefault();
    }
  });
  var refreshDialogIndexes = function refreshDialogIndexes() {
    _.each(_.initial(openedDialogs), function (dialog) {
      dialog.scope.$zIndex = 1000;
    });
    _.last(openedDialogs).scope.$zIndex = 1100;
  };

  // container

  var createContainer = function createContainer() {
    if (container != null) {
      return;
    }
    var containerScope = $rootScope.$new(true);
    $compile('<modal-container></modal-container>')(containerScope, function (_container) {
      container = _container;
      $("body").append(container);
    });
  };

  // TODO : container is probably useless. Should append modals to body and remove this

  var showContainer = function showContainer() {
    if (container == null) {
      createContainer();
    }
  };
  var hideContainer = function hideContainer() {
    if (container != null) {
      container.scope() && container.scope().$destroy();
      container.remove();
      container = null;
    }
  };

  // overlay

  var createOverlay = function createOverlay() {
    if (overlay != null) {
      return;
    }
    var overlayScope = $rootScope.$new(true);
    $compile('<modal-overlay></modal-overlay>')(overlayScope, function (_overlay) {
      overlay = _overlay;
      $("body").append(overlay);
    });
  };
  var showOverlay = function showOverlay() {
    if (overlay == null) {
      createOverlay();
    }
    if (overlay) {
      $animate.addClass(overlay, "visible");
    }
  };
  var hideOverlay = function hideOverlay() {
    var oldOverlay = overlay;
    overlay && overlay.scope() && overlay.scope().$destroy();
    if (oldOverlay) {
      $animate.removeClass(oldOverlay, "visible").then(function () {
        oldOverlay.remove();
      });
    }
    overlay = null;
  };

  // dialog
  var openDialog = function openDialog(modal) {
    if (openedDialogs.length === 0) {
      showContainer();
      showOverlay();
      bindKeyboardEvents();
    }
    return createDialog(modal);
  };
  var createDialog = function createDialog(modal) {
    var dialogEl = $('<modal-dialog>');
    dialogEl.html(modal.template);
    $compile(dialogEl)(modal.scope, function (dialog) {
      modal.element = dialog;
      openedDialogs.push(modal);
      container.append(dialog);
    });
    refreshDialogIndexes();
    return modal.element;
  };
  var closeDialog = function closeDialog(dialog) {
    var dialogIndex = _.indexOf(openedDialogs, dialog);
    openedDialogs.splice(dialogIndex, 1);
    var isLastDialog = function isLastDialog() {
      return openedDialogs.length === 0;
    };
    $animate.addClass(dialog.element.find(".tl-modal-content"), "tla-removing").then(function () {
      dialog.scope.$destroy();
      dialog.element.remove();
      if (isLastDialog()) {
        hideContainer();
      }
    });
    if (isLastDialog()) {
      unbindKeyboardEvents();
      hideOverlay();
    } else {
      refreshDialogIndexes();
    }
  };
  var keydownHandler = function keydownHandler(event) {
    var dialog = getCurrentDialog();
    if (!dialog.options.options.escape) {
      return;
    }
    var dialogScope = dialog.scope;
    if (event.which === keyCodes.ESCAPE) {
      dialogScope.$apply(function () {
        dialogScope.$dismiss();
      });
    }
  };
  var bindKeyboardEvents = function bindKeyboardEvents() {
    $($window).keydown(keydownHandler);
  };
  var unbindKeyboardEvents = function unbindKeyboardEvents() {
    $($window).unbind("keydown", keydownHandler);
  };
  var getCurrentDialog = function getCurrentDialog() {
    return _.last(openedDialogs);
  };
  $modal.open = function (modalOptions) {
    var dialogResultDeferred = $q.defer();
    var dialogResultPromise = dialogResultDeferred.promise;

    // merge and clean up options
    modalOptions.resolve = modalOptions.resolve || {};
    modalOptions.options = _objectSpread({}, $modalDefaultOptions, {}, modalOptions.options);

    // verify options
    if (!modalOptions.template && !modalOptions.templateUrl) {
      throw new Error('One of template or templateUrl options is required.');
    }
    var resolvesPromise = deferredUtils.resolvePromiseMap(modalOptions.resolve);
    var templatePromise = templateUtils.loadTemplate(modalOptions);
    $q.all([resolvesPromise, templatePromise]).then(function (resolves) {
      var locals = resolves[0];
      var template = resolves[1];
      var dialogScope = (modalOptions.scope || $rootScope).$new();
      var dialogId = _.uniqueId("$dialog-");
      var dialog = {
        id: dialogId,
        options: modalOptions,
        scope: dialogScope,
        deferred: dialogResultDeferred,
        promise: dialogResultPromise,
        template: template,
        resolve: locals
      };
      if (modalOptions.vars) {
        _.extend(dialogScope, modalOptions.vars);
      }
      _.extend(dialogScope, {
        $dialogId: dialogId,
        modalOptions: modalOptions.options || {},
        $close: function $close(value) {
          closeDialog(dialog);
          dialogResultDeferred.resolve(value);
        },
        $dismiss: function $dismiss(reason) {
          closeDialog(dialog);
          dialogResultDeferred.reject(reason);
        }
      });
      var element = openDialog(dialog);
      _.extend(locals, {
        $element: element
      });

      // controller
      if (modalOptions.controller) {
        locals.$scope = dialogScope;
        locals.$dialog = dialog;
        dialog.ctrl = $controller(modalOptions.controller, locals);
      }

      // controllerAs alias
      dialogScope[modalOptions.controllerAs || "$ctrl"] = dialog.ctrl;
    });
    return dialogResultPromise;
  };
  $modal.isOpen = function () {
    return openedDialogs.length > 0;
  };
  $modal.dismiss = function (modalPromise) {
    _.each(openedDialogs, function (dialog) {
      if (dialog != null && dialog.promise === modalPromise) {
        dialog.scope.$dismiss();
      }
    });
  };
  $modal.dismissAll = function () {
    _.each(openedDialogs, function (dialog) {
      dialog.scope.$dismiss();
    });
  };
  return $modal;
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/dialogs/$modal.js
// module id = 2930
// module chunks = 13